import React from "react";
import BackButton from "../GoBack/GoBack";
import { useNavigate } from "react-router-dom";
import { StudentMapMenu } from "../Map/MapMenu/MapMenu";

export const StudentAdminCertificateOption = () => {
  const navigate = useNavigate();
  return (
    <div className="StudentAdminBody StudentBodyMrgn ">
      {/* <img className="circleTopBar" src={TopCircle} alt="" /> */}
      <div className="container-fluid">
        <div className="teacher-bodycontent mb-5">
          <section>
            <div className="row mb-4">
              <div className="col-md-12">
                <BackButton />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-1"></div>

              <div className="col-md-10 row justify-content-center">
              <div className="position-relative text-center">
                  {/* Desktop Image */}
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/BlueBanner.png"
                    alt="quest"
                    className="img-fluid w-100 d-none d-md-block"
                    style={{ objectFit: "cover", height: "auto" }}
                  />

                  {/* Mobile Image */}
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/BlueBannerMobile.png"
                    alt="quest"
                    className="img-fluid w-100 d-block d-md-none"
                    style={{ objectFit: "cover", height: "auto" }}
                  />

                  {/* Centered Text */}
                  <div
                    className="position-absolute top-50 start-50 translate-middle text-white text-center"
                    style={{
                      width: "100%",
                      padding: "0 1rem",
                      maxWidth: "100%",
                    }}
                  >
                    <h6 className="fw-semibold display-6 m-0">Awards</h6>
                    <p className="fs-5 m-0">Your Journey Through Learning</p>
                  </div>
                </div>
                <div className="col-md-2"></div>
                <div className="container" style={{ marginTop: "50px" }}>
                  <div className="row justify-content-center gy-4 gx-md-4">
                    <div className="col-12 col-md-5 col-lg-4 ">
                      <div className="card shadow-lg border-0.5px rounded-4 p-4 text-center h-100 d-flex flex-column">
                        <div
                          className="flex-grow-1 d-flex align-items-center justify-content-center"
                          style={{ minHeight: "180px" }}
                        >
                          <img
                            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/certificate/allcertificate.png"
                            alt="Certificate"
                            className="img-fluid"
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h5
                            className="fw-bold  text-uppercase mb-3"
                            style={{ color: "#0037AC" }}
                          >
                            Certificates
                          </h5>
                          <p className="text-muted mb-4">
                            Collect certificates for every milestone and display
                            your learning journey with pride.
                          </p>
                        </div>
                        <div className="mt-auto">
                          <div
                            className="px-5 py-2 text-center mx-auto rounded-4"
                            style={{
                              background: "#0037AC",
                              color: "white",
                              width: "fit-content",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate("/student/admin/certificates");
                            }}
                          >
                            View all
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5 col-lg-4">
                      <div
                        className="card shadow-lg border-0 rounded-4 p-4 text-center h-100 d-flex flex-column"
                        style={{ background: "#0037AC" }}
                      >
                        {/* Image section with flexible space */}
                        <div
                          className="flex-grow-1 d-flex align-items-center justify-content-center position-relative mb-4"
                          style={{ minHeight: "180px" }}
                        >
                          {/* Trophy image */}
                          <img
                            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/trophy/alltrophy.png"
                            alt="Trophy"
                            className="img-fluid"
                            style={{ zIndex: 2 }}
                          />
                        </div>

                        {/* Text content */}
                        <div className="flex-grow-1">
                          <h5
                            className="fw-bold text-uppercase mb-3"
                            style={{ color: "white" }}
                          >
                            Trophies
                          </h5>
                          <p className="mb-4" style={{ color: "white" }}>
                            Every quest you conquer brings you closer to
                            greatness.
                          </p>
                        </div>

                        {/* Button area */}
                        <div className="mt-auto">
                          <div
                            className="px-5 py-2 text-center mx-auto rounded-4"
                            style={{
                              background: "white",
                              color: "#0037AC",
                              width: "fit-content",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate("/student/admin/trophy");
                            }}
                          >
                            View all
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-2"></div>
              </div>
              <div className="col-md-1"></div>
            </div>
            <div>
              <StudentMapMenu />
            </div>
          </section>
          <div style={{ position: "absolute" }}>
            {/* Left Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
              alt="left"
              className="position-fixed"
              style={{
                left: 0,
                top: "10vh",
                height: "90vh",
                bottom: "auto",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Right Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
              alt="right"
              className="position-fixed"
              style={{
                right: 0,
                top: "20vh",
                height: "70vh",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Page Content */}
          </div>
        </div>
      </div>
    </div>
  );
};
